import { Box, Button, Text, Title } from '@holbonkit/ui'

import styles from './announce.module.scss'

import { IllustrationDocuments } from '@/assets'

type TAnnounceProps = {
    onNext: () => void
}

export const Announce = ({ onNext }: TAnnounceProps) => {
    return (
        <Box className={styles['announce']} pb={4} px={4}>
            <img
                alt='announcement'
                className={styles['announce__illustration']}
                src={IllustrationDocuments}
            />
            <Box className={styles.content}>
                <Title variant='header-24-bold'>Подготовьте документы</Title>
                <Box className={styles['content__description']}>
                    <Text
                        as='p'
                        className={styles['content__description--secondary']}
                        variant='body-m-16-regular'
                    >
                        Для анкеты понадобятся паспорт и ИНН.
                    </Text>
                    <Text
                        as='p'
                        className={styles['content__description--secondary']}
                        variant='body-m-16-regular'
                    >
                        Часть ваших данных вставится автоматически, если они есть в ФНС или вы
                        проходили нашу проверку
                    </Text>
                </Box>
            </Box>
            <Button
                fullWidth
                className={styles['announce__button']}
                size='lg'
                variant='primary'
                onClick={onNext}
            >
                Далее
            </Button>
        </Box>
    )
}
